import { AT } from '../../actions/actionTypes';
import { store } from '../../index';
import Logger from '../../libs/logger';   import { LogArea } from '../../libs/logger/const';

export const setRightPanel = (dialogId: string) => {
  Logger.info(['setDialog', dialogId], LogArea.Redux);
  const action = {
    type: AT.DIALOG_ACTIVE_CHANGED,
    payload: dialogId,
  };

  store.dispatch(action);
};

export const setModal = (dialogId: string) => {
  Logger.info(['setModal', dialogId], LogArea.Redux);
  const action = {
    type: AT.MODAL_ACTIVE_CHANGED,
    payload: dialogId,
  };

  store.dispatch(action);
};
